import { HgProductCategory } from "../../../types/taxonomy";
import { TreeItem } from "../components/TreeView/types";

export const sortProductCategories = (categories: HgProductCategory[]) => {
  return [...categories].sort((a, b) => a.name.localeCompare(b.name));
};

export const getProductCategoriesTree = (
  targetCategories: HgProductCategory[],
  allCategories: HgProductCategory[]
): TreeItem[] => {
  if (targetCategories.length === 0) {
    return [];
  }

  return targetCategories.map((category) => {
    const children = allCategories.filter(
      ({ parentId }) => parentId === category.id
    );

    return {
      id: category.id,
      label: category.name,
      children: getProductCategoriesTree(children, allCategories),
    };
  });
};

export const getCategoryLeafDescendantIds = (
  category: HgProductCategory,
  allCategories: HgProductCategory[]
) => {
  const getChildIds = ({ id }: HgProductCategory) => {
    let ids: string[] = [id];

    const childCategories = allCategories.filter(
      ({ parentId }) => parentId === id
    );

    for (const child of childCategories) {
      const childIds = getChildIds(child);

      ids = [...ids, ...childIds];
    }

    return ids;
  };

  return getChildIds(category);
};
